import React from 'react';
import PropTypes from 'prop-types';
import DetailView from 'src/components/Dashboard/components/DetailView';
import CaseDetailsView from 'src/components/Cases/components/Detail/CaseDetailsView';
import ReferralDetail from 'src/components/Referrals/ReferralDetail/index';
import { browserHistory } from 'common/utils/browserHistory';
import { isAcceptedOpenOrClosed } from 'src/components/Dashboard/components/Referrals/SentReferrals/utils';

const navigateToSentReferrals = () => {
  browserHistory.push('/dashboard/referrals/sent/all');
};

const SentReferralDetailView = ({
  route,
  params,
  location,
  source,
}) => {
  const innerContentView = !isAcceptedOpenOrClosed(route.status) ? (
    <ReferralDetail
      subjectType="referral"
      key={params.id}
      location={location}
      params={params}
      type="sentReferrals"
      showContactColumn
    />
  ) : (
    <CaseDetailsView
      params={params}
      type="allCases"
      showContactColumn
      subjectType="case"
    />
  );

  const onBackClickHandler = source === 'referral' ? navigateToSentReferrals : null;

  return (
    <DetailView
      innerContentView={innerContentView}
      onBackClick={onBackClickHandler}
    />
  );
};

SentReferralDetailView.propTypes = {
  route: PropTypes.shape({
    status: PropTypes.string,
  }).isRequired,
  params: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  source: PropTypes.string,
};

SentReferralDetailView.defaultProps = {
  source: '',
};

export default SentReferralDetailView;
